import { connect } from "react-redux";
import PropTypes from "prop-types";
import WebsiteTunnelSwitcher from "./WebsiteTunnelSwitcher";
import { getAvailableStopoverCities } from "app/pages/SmartDP/smartDPSelectors";

const WebsiteTunnelSwitcherContainer = ({ stopoverCities, ...props }) => {
	return <WebsiteTunnelSwitcher stopoverCities={stopoverCities} {...props} />;
};

const mapStateToProps = state => {
	return { stopoverCities: getAvailableStopoverCities(state) };
};

WebsiteTunnelSwitcherContainer.propTypes = {
	stopoverCities: PropTypes.array,
};

export default connect(mapStateToProps)(WebsiteTunnelSwitcherContainer);
